import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getDepositAccountDetailsPath = (id: string = ':id') => urlHelper(`/deposit-accounts/${id}/details`);
